import Phaser from "phaser";
import type { BattleSession } from "../app/BattleSession.js";
import { PHASER_VIEW_HEIGHT, PHASER_VIEW_WIDTH } from "./constants.js";
import { BattleScene } from "./scenes/BattleScene.js";
import { BootScene } from "./scenes/BootScene.js";

export function createGame(parent: string, session?: BattleSession): Phaser.Game {
  const rendererType = new URLSearchParams(window.location.search).get("renderer") === "canvas"
    ? Phaser.CANVAS
    : Phaser.AUTO;

  return new Phaser.Game({
    type: rendererType,
    parent,
    width: PHASER_VIEW_WIDTH,
    height: PHASER_VIEW_HEIGHT,
    backgroundColor: "#0b1d25",
    transparent: false,
    antialias: true,
    render: {
      antialias: true,
      pixelArt: false,
      roundPixels: false,
    },
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: PHASER_VIEW_WIDTH,
      height: PHASER_VIEW_HEIGHT,
    },
    scene: [BootScene, new BattleScene(session)],
  });
}
